<div class="crp-list-card">
  <div ubi-curve-header class="crp-list-card__header">
    <span class="crp-list-card__header-text">
      {{ 'crp.header' | translate }}
    </span>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('crp.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="crp-list-card__content-container">
    <div class="crp-list-card__tool-bar">
      <button mat-button class="btn btn_accent-gradient-rounded crp-list-card__add-crp-btn" ubi-round-button
        (click)="toAddCrp()">+ {{ 'crp.button.add' | translate }} </button>
      <mat-form-field class="custom-mat-form-field crp-list-card__search-field">
        <input matInput (keyup)="searchCrpList($event.target.value)" placeholder="{{ 'general.search.label.search_by_name' | translate }}" autocomplete="off">
        <img matSuffix class="themified-white-icon crp-list-card__search-icon" src="/assets/icons/magnifying-glass-icon.png">
      </mat-form-field>
    </div>
    <div class="crp-list-card__table-and-paginator">
      <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
      <div class="crp-table-container">
        <table mat-table class="custom-mat-table crp-table" matSort [dataSource]="dataSource">
          <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.table.label.name' | translate }} </th>
            <td mat-cell *matCellDef="let item" class="crp-table__cell crp-table-name">{{item.name}}</td>
          </ng-container>
          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.role' | translate }} </th>
            <td mat-cell *matCellDef="let item" class="crp-table__cell">
              {{item.roles ? item.roles : '-'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.table.label.status' | translate }} </th>
            <td mat-cell *matCellDef="let item" class="crp-table__cell">{{item.status}}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="crp-table__header_actions"> {{ 'general.table.label.actions' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              <ng-container *ngIf="!item.primary">
                <img [routerLink]="['/customers', currentCustomerId, 'edit', 'crp-edit', item.id ]"
                  class="themified-white-icon link crp-table__action-icon" src="/assets/icons/edit-icon.png" title="Edit">
                <img class="themified-white-icon crp-table__action-icon" src="/assets/icons/minus-icon-white.png" title="Delete"
                     *ngIf="!(isUserOnlyL1$ | async)" (click)="deleteCrp(item.id)">
              </ng-container>
              <ng-container *ngIf="item.primary">
                <span> {{ 'crp.message.no_action' | translate }} </span>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'crp-table__resigned-row': row.status === 'RESIGNED'}"></tr>
        </table>
      </div>
      <div class="table-empty" *ngIf="paginator.length === 0">
        {{ 'crp.message.no_crp' | translate }}
      </div>
      <mat-paginator class="custom-mat-paginator" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
